import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import { ButtonNext } from "wix-ui-core/dist/es/src/components/button-next";
import PropTypes from 'prop-types';
import { iconChildSize } from './constants';
import { generateDataAttr } from '../utils/generateDataAttr';
import cx from 'classnames';
import styles from './IconButton.st.css';

var IconButton = /*#__PURE__*/function (_PureComponent) {
  _inherits(IconButton, _PureComponent);

  var _super = _createSuper(IconButton);

  function IconButton() {
    _classCallCheck(this, IconButton);

    return _super.apply(this, arguments);
  }

  _createClass(IconButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          skin = _this$props.skin,
          userClassName = _this$props.className,
          priority = _this$props.priority,
          size = _this$props.size,
          children = _this$props.children,
          dataHook = _this$props.dataHook,
          rest = _objectWithoutProperties(_this$props, ["skin", "className", "priority", "size", "children", "dataHook"]);

      var childSize = iconChildSize[size];

      var _styles = styles('root', {
        skin: skin,
        priority: priority,
        size: size
      }),
          className = _styles.className;

      var classNames = cx(className, userClassName);
      return /*#__PURE__*/React.createElement(ButtonNext, _extends({}, rest, styles('root', {
        skin: skin,
        priority: priority,
        size: size
      }, this.props), generateDataAttr(this.props, ['skin', 'priority', 'size']), {
        "data-hook": dataHook,
        className: classNames
      }), children && /*#__PURE__*/React.cloneElement(children, {
        size: childSize,
        width: childSize,
        height: childSize
      }));
    }
  }]);

  return IconButton;
}(PureComponent);

_defineProperty(IconButton, "displayName", 'IconButton');

_defineProperty(IconButton, "propTypes", {
  /** render as some other component or DOM tag */
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.string]),

  /** Classes to be applied to the root element */
  className: PropTypes.string,

  /** Used for passing any wix-style-react icon. For external icon make sure to follow ux sizing guidelines */
  children: PropTypes.node,

  /** Button skins */
  skin: PropTypes.oneOf(['standard', 'inverted', 'light', 'transparent', 'premium']),

  /** Button priority */
  priority: PropTypes.oneOf(['primary', 'secondary']),

  /** Button size */
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large']),

  /** Click event handler  */
  onClick: PropTypes.func,

  /** Applies disabled styles */
  disabled: PropTypes.bool,

  /** String based data hook */
  dataHook: PropTypes.string
});

_defineProperty(IconButton, "defaultProps", {
  skin: 'standard',
  priority: 'primary',
  size: 'medium',
  disabled: false
});

export default IconButton;